import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useWebsiteSocialLogic } from './hooks/useWebsiteSocialLogic';
import { WebsiteSocialForm } from './WebsiteSocialForm';

export const EddWebsiteSocial = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useWebsiteSocialLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('organic.websiteSocial.title')}
        headingContainerCustomStyle='!mb-[16px]'
        textCustomStyle='text-text-main-primary text-[16px] mt-[24px] whitespace-pre-line'>
        <WebsiteSocialForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
